@if (!hideSidebar()) {
  <div id="sidebar" class="z-40 flex fixed transition-all duration-300 lg:static"
       [ngClass]="{'-left-96': !visible, 'left-0': visible}">
    <div [class]="'w-80 h-svh px-6 pb-4 flex flex-col border-r border-r-slate-200/80 bg-slate-50/60 dark:bg-gray-900 dark:border-r-white/30'">

      <div class="h-16 flex-shrink-0 flex items-center justify-between">

        <a routerLink="/dashboard" class="flex items-center">
          <svg xmlns="http://www.w3.org/2000/svg"
               viewBox="0 0 185 50"
               fill="none"
               role="img"
               aria-labelledby="logoTitle"
               class="h-10 w-auto cursor-pointer"
               preserveAspectRatio="xMinYMid meet">
            <title id="logoTitle">Blinth Logo</title>

            <rect x="2" y="5" width="40" height="40" rx="10" fill="#4F46E5"/>

            <path d="M12 25H32M12 18H28M12 32H22"
                  stroke="white"
                  stroke-width="3"
                  stroke-linecap="round"/>

            <text x="50" y="25"
                  font-family="Inter, system-ui, sans-serif"
                  font-weight="900"
                  font-size="28"
                  letter-spacing="-0.03em"
                  dominant-baseline="central"
                  class="fill-gray-900 dark:fill-white">
              BLINTH<tspan fill="#4F46E5" dominant-baseline="central">.</tspan>
            </text>
          </svg>
        </a>

        <button class="flex justify-center items-center lg:hidden p-2 -mr-2 text-gray-700 dark:text-gray-400 hover:text-indigo-600 transition-colors"
                (click)="close()">
          <i class="fa-solid fa-xmark text-2xl"></i>
        </button>
      </div>

      <nav class="flex-1 overflow-y-auto no-scrollbar py-4">
        <ul class="flex flex-col gap-y-1">
          <li>
            <a routerLink="/dashboard"
               routerLinkActive="bg-white/80 shadow-xs text-indigo-600 [&>i]:text-indigo-600 dark:bg-white/10 dark:text-white dark:[&>i]:text-white"
               class="p-2 rounded-md flex items-center gap-x-3 text-base font-semibold text-gray-700 hover:bg-white/80 hover:shadow-xs hover:text-indigo-600 dark:text-gray-400 dark:hover:bg-white/10 dark:hover:text-white group transition-all"
               (click)="close()">
              <i class="fa-regular fa-house text-xl text-gray-400 group-hover:text-indigo-600 dark:group-hover:text-white transition-colors"></i>
              <span>Dashboard</span>
            </a>
          </li>

          @if (environment.app || (isLogged() && (user()?.user?.plan || user()?.user?.representedEmployee))) {
            <li>
              <a routerLink="/clienti"
                 routerLinkActive="bg-white/80 shadow-xs text-indigo-600 [&>i]:text-indigo-600 dark:bg-white/10 dark:text-white dark:[&>i]:text-white"
                 class="p-2 rounded-md flex items-center gap-x-3 text-base font-semibold text-gray-700 hover:bg-white/80 hover:shadow-xs hover:text-indigo-600 dark:text-gray-400 dark:hover:bg-white/10 dark:hover:text-white group transition-all"
                 (click)="close()">
                <i class="fa-solid fa-users text-xl text-gray-400 group-hover:text-indigo-600 dark:group-hover:text-white transition-colors"></i>
                <span>Clienti</span>
              </a>
            </li>

            <li>
              <a routerLink="/recall"
                 routerLinkActive="bg-white/80 shadow-xs text-indigo-600 [&>div>i]:text-indigo-600 dark:bg-white/10 dark:text-white dark:[&>div>i]:text-white"
                 class="p-2 rounded-md flex items-center justify-between text-base font-semibold text-gray-700 hover:bg-white/80 hover:shadow-xs hover:text-indigo-600 dark:text-gray-400 dark:hover:bg-white/10 dark:hover:text-white group transition-all"
                 (click)="close()">
                <div class="flex items-center gap-x-3">
                  <i class="fa-solid fa-phone text-xl text-gray-400 group-hover:text-indigo-600 dark:group-hover:text-white transition-colors"></i>
                  <span>Recall</span>
                </div>

                @if (notificationService.hasRecallsBadge()) {
                  <span class="relative flex h-2.5 w-2.5 mr-1">
                    <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
                    <span class="relative inline-flex rounded-full h-2.5 w-2.5 bg-red-500"></span>
                  </span>
                }
              </a>
            </li>

            @if (environment.app || !user()?.user?.representedEmployee) {
              <li>
                <a routerLink="/collaboratori"
                   routerLinkActive="bg-white/80 shadow-xs text-indigo-600 [&>i]:text-indigo-600 dark:bg-white/10 dark:text-white dark:[&>i]:text-white"
                   class="p-2 rounded-md flex items-center gap-x-3 text-base font-semibold text-gray-700 hover:bg-white/80 hover:shadow-xs hover:text-indigo-600 dark:text-gray-400 dark:hover:bg-white/10 dark:hover:text-white group transition-all"
                   (click)="close()">
                  <i class="fa-solid fa-sitemap text-xl text-gray-400 group-hover:text-indigo-600 dark:group-hover:text-white transition-colors"></i>
                  <span>Collaboratori</span>
                </a>
              </li>

              <li class="my-2 border-t border-slate-200/70 dark:border-white/5"></li>

              <li>
                <a routerLink="/caffe"
                   routerLinkActive="bg-white/80 shadow-xs text-indigo-600 [&>i]:text-indigo-600 dark:bg-white/10 dark:text-white dark:[&>i]:text-white"
                   class="p-2 rounded-md flex items-center gap-x-3 text-base font-semibold text-gray-700 hover:bg-white/80 hover:shadow-xs hover:text-indigo-600 dark:text-gray-400 dark:hover:bg-white/10 dark:hover:text-white group transition-all"
                   (click)="close()">
                  <i class="fa-solid fa-mug-saucer text-xl text-gray-400 group-hover:text-indigo-600 dark:group-hover:text-white transition-colors"></i>
                  <span>Caffè</span>
                </a>
              </li>
              <li>
                <a routerLink="/prodotti"
                   routerLinkActive="bg-white/80 shadow-xs text-indigo-600 [&>i]:text-indigo-600 dark:bg-white/10 dark:text-white dark:[&>i]:text-white"
                   class="p-2 rounded-md flex items-center gap-x-3 text-base font-semibold text-gray-700 hover:bg-white/80 hover:shadow-xs hover:text-indigo-600 dark:text-gray-400 dark:hover:bg-white/10 dark:hover:text-white group transition-all"
                   (click)="close()">
                  <i class="fa-solid fa-box-open text-xl text-gray-400 group-hover:text-indigo-600 dark:group-hover:text-white transition-colors"></i>
                  <span>Consumo</span>
                </a>
              </li>
              <li>
                <a routerLink="/promozioni"
                   routerLinkActive="bg-white/80 shadow-xs text-indigo-600 [&>i]:text-indigo-600 dark:bg-white/10 dark:text-white dark:[&>i]:text-white"
                   class="p-2 rounded-md flex items-center gap-x-3 text-base font-semibold text-gray-700 hover:bg-white/80 hover:shadow-xs hover:text-indigo-600 dark:text-gray-400 dark:hover:bg-white/10 dark:hover:text-white group transition-all"
                   (click)="close()">
                  <i class="fa-solid fa-percent text-xl text-gray-400 group-hover:text-indigo-600 dark:group-hover:text-white transition-colors"></i>
                  <span>Promozioni</span>
                </a>
              </li>
              <li>
                <a routerLink="/dispositivi"
                   routerLinkActive="bg-white/80 shadow-xs text-indigo-600 [&>i]:text-indigo-600 dark:bg-white/10 dark:text-white dark:[&>i]:text-white"
                   class="p-2 rounded-md flex items-center gap-x-3 text-base font-semibold text-gray-700 hover:bg-white/80 hover:shadow-xs hover:text-indigo-600 dark:text-gray-400 dark:hover:bg-white/10 dark:hover:text-white group transition-all"
                   (click)="close()">
                  <i class="fa-solid fa-microchip text-xl text-gray-400 group-hover:text-indigo-600 dark:group-hover:text-white transition-colors"></i>
                  <span>Dispositivi</span>
                </a>
              </li>
              <li>
                <a routerLink="/ricambi"
                   routerLinkActive="bg-white/80 shadow-xs text-indigo-600 [&>i]:text-indigo-600 dark:bg-white/10 dark:text-white dark:[&>i]:text-white"
                   class="p-2 rounded-md flex items-center gap-x-3 text-base font-semibold text-gray-700 hover:bg-white/80 hover:shadow-xs hover:text-indigo-600 dark:text-gray-400 dark:hover:bg-white/10 dark:hover:text-white group transition-all"
                   (click)="close()">
                  <i class="fa-solid fa-arrows-rotate text-xl text-gray-400 group-hover:text-indigo-600 dark:group-hover:text-white transition-colors"></i>
                  <span>Ricambi</span>
                </a>
              </li>
            }
            <li>
              <a routerLink="/vendite"
                 routerLinkActive="bg-white/80 shadow-xs text-indigo-600 [&>i]:text-indigo-600 dark:bg-white/10 dark:text-white dark:[&>i]:text-white"
                 class="p-2 rounded-md flex items-center gap-x-3 text-base font-semibold text-gray-700 hover:bg-white/80 hover:shadow-xs hover:text-indigo-600 dark:text-gray-400 dark:hover:bg-white/10 dark:hover:text-white group transition-all"
                 (click)="close()">
                <i class="fa-solid fa-file-invoice-dollar text-xl text-gray-400 group-hover:text-indigo-600 dark:group-hover:text-white transition-colors"></i>
                <span>Vendite</span>
              </a>
            </li>
          }

          <li class="my-2 border-t border-slate-200/70 dark:border-white/5"></li>

          @if (isLogged()) {
            <li>
              <a routerLink="/statistiche/vendite"
                 routerLinkActive="bg-white/80 shadow-xs text-indigo-600 [&>i]:text-indigo-600 dark:bg-white/10 dark:text-white dark:[&>i]:text-white"
                 class="p-2 rounded-md flex items-center gap-x-3 text-base font-semibold text-gray-700 hover:bg-white/80 hover:shadow-xs hover:text-indigo-600 dark:text-gray-400 dark:hover:bg-white/10 dark:hover:text-white group transition-all"
                 (click)="close()">
                <i class="fa-solid fa-chart-line text-xl text-gray-400 group-hover:text-indigo-600 dark:group-hover:text-white transition-colors"></i>
                <span>Statistiche</span>
              </a>
            </li>
            <li>
              <a routerLink="/strumenti"
                 routerLinkActive="bg-white/80 shadow-xs text-indigo-600 [&>div>i]:text-indigo-600 dark:bg-white/10 dark:text-white dark:[&>div>i]:text-white"
                 class="p-2 rounded-md flex items-center justify-between text-base font-semibold text-gray-700 hover:bg-white/80 hover:shadow-xs hover:text-indigo-600 dark:text-gray-400 dark:hover:bg-white/10 dark:hover:text-white group transition-all"
                 (click)="close()">
                <div class="flex items-center gap-x-3">
                  <i class="fa-solid fa-wrench text-xl text-gray-400 group-hover:text-indigo-600 dark:group-hover:text-white transition-colors"></i>
                  <span>Strumenti</span>
                </div>

                @if (notificationService.hasBirthdaysBadge()) {
                  <span class="relative flex h-2.5 w-2.5 mr-1">
                    <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
                    <span class="relative inline-flex rounded-full h-2.5 w-2.5 bg-emerald-500"></span>
                  </span>
                }
              </a>
            </li>
            <li>
              <a routerLink="/impostazioni/generali"
                 routerLinkActive="bg-white/80 shadow-xs text-indigo-600 [&>i]:text-indigo-600 dark:bg-white/10 dark:text-white dark:[&>i]:text-white"
                 class="p-2 rounded-md flex items-center gap-x-3 text-base font-semibold text-gray-700 hover:bg-white/80 hover:shadow-xs hover:text-indigo-600 dark:text-gray-400 dark:hover:bg-white/10 dark:hover:text-white group transition-all"
                 (click)="close()">
                <i class="fa-solid fa-gear text-xl text-gray-400 group-hover:text-indigo-600 dark:group-hover:text-white transition-colors"></i>
                <span>Impostazioni</span>
              </a>
            </li>
          }

          <!-- VOCE ADMIN (senza condizioni) -->
          @if (profileSync.isAdmin() && !environment.app) {
            <li>
              <a routerLink="/admin/abbonamenti"
                 routerLinkActive="bg-white/80 shadow-xs text-purple-600 [&>div>i]:text-purple-600 dark:bg-white/10 dark:text-purple-300 dark:[&>div>i]:text-purple-300"
                 class="p-2 rounded-md flex items-center justify-between text-base font-semibold text-gray-700 hover:bg-white/80 hover:shadow-xs hover:text-purple-600 dark:text-gray-400 dark:hover:bg-white/10 dark:hover:text-purple-300 group transition-all"
                 (click)="close()">
                <div class="flex items-center gap-x-3">
                  <i class="fa-solid fa-sliders text-xl text-gray-400 group-hover:text-purple-600 dark:group-hover:text-purple-300 transition-colors"></i>
                  <span>Pannello Admin</span>
                </div>

                <span class="text-[10px] font-semibold tracking-wide px-2 py-0.5 rounded-full bg-purple-50 text-purple-600 border border-purple-200/70 dark:bg-purple-950/40 dark:text-purple-300 dark:border-purple-800/50">
                  HQ
                </span>
              </a>
            </li>
          }

          @if (!environment.app) {
            <li>
              <a routerLink="/aiuto/faq"
                 routerLinkActive="bg-white/80 shadow-xs text-indigo-600 [&>i]:text-indigo-600 dark:bg-white/10 dark:text-white dark:[&>i]:text-white"
                 class="p-2 rounded-md flex items-center gap-x-3 text-base font-semibold text-gray-700 hover:bg-white/80 hover:shadow-xs hover:text-indigo-600 dark:text-gray-400 dark:hover:bg-white/10 dark:hover:text-white group transition-all"
                 (click)="close()">
                <i class="fa-solid fa-question text-xl text-gray-400 group-hover:text-indigo-600 dark:group-hover:text-white transition-colors"></i>
                <span>Aiuto</span>
              </a>
            </li>
          }

          @if (!environment.app && !pwaService.isStandalone() && pwaService.canInstall()) {
            <li class="mt-3">
              <button type="button"
                      (click)="pwaService.install(); close()"
                      class="w-full p-2.5 rounded-xl flex items-center justify-between text-sm font-bold bg-indigo-50/80 hover:bg-indigo-100 text-indigo-700 border border-indigo-200/60 dark:bg-indigo-950/40 dark:hover:bg-indigo-900/50 dark:text-indigo-300 dark:border-indigo-800/40 transition-all duration-200 group cursor-pointer shadow-xs">
                <div class="flex items-center gap-x-3">
                  <div class="w-8 h-8 rounded-lg bg-indigo-600 text-white flex items-center justify-center shrink-0 group-hover:scale-105 transition-transform">
                    <i class="fa-solid fa-download text-sm"></i>
                  </div>
                  <div class="text-left flex flex-col">
                    <span class="leading-tight font-bold">Installa App</span>
                    <span class="text-[11px] font-normal text-indigo-500 dark:text-indigo-400">Accesso rapido</span>
                  </div>
                </div>
                <i class="fa-solid fa-arrow-right text-xs text-indigo-400 group-hover:translate-x-0.5 transition-transform"></i>
              </button>
            </li>
          }
        </ul>
      </nav>

      <div class="mt-auto pt-4 flex-shrink-0 border-t border-slate-200/80 dark:border-white/10 flex items-center justify-between">
        <div class="flex items-center gap-x-3 text-sm font-semibold text-gray-700 dark:text-gray-400">
          <i class="fa-solid" [ngClass]="theme === 'dark' ? 'fa-moon' : 'fa-sun'"></i>
          <span>Tema scuro</span>
        </div>

        <dm-input-switch
          [active]="theme === 'dark'"
          [scale]="0.7"
          [autoToggle]="false"
          (switch)="toggleTheme()">
        </dm-input-switch>
      </div>
    </div>
  </div>
}
